export const CHANGE_SELECTED_SHOP = 'CHANGE_SELECTED_SHOP';